export const types = {
    ASSIGN: 'ASSIGN',
    APPEND: 'APPEND'

};
